/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { FIELD_TYPES } from './isSystemFieldType.tsx';
import type { Field, FieldConfiguration } from './FieldKey.types.tsx';
import { INTERVAL_FIELD_SOURCES } from './IntervalFieldSources.tsx';

export const isIntervalFieldSourcesKey = (
	source: string,
): source is keyof typeof INTERVAL_FIELD_SOURCES => source in INTERVAL_FIELD_SOURCES;

export const isValidDeliveryDateConfiguration = (
	configuration: FieldConfiguration | undefined,
): boolean =>
	!!(
		configuration &&
		configuration.source === INTERVAL_FIELD_SOURCES.DELIVERY_DATE &&
		configuration.customfieldKey &&
		configuration.aggregationType
	);

export const isIntervalFieldWithDeliveryDateConfig = (field: Field): boolean =>
	field.type === FIELD_TYPES.INTERVAL && isValidDeliveryDateConfiguration(field.configuration);
